import {
  Breadcrumbs,
  React,
  Redirect,
  Route,
  Switch,
  withRouter,
} from '@1337lawyers/design';

import { AccountHistory } from './accountHistory';
import { CompletedVerificationRequests } from './completed';
import Dashboard from './dashboard';
import NewVerification from './newVerification';
import { PendingVerificationRequests } from './pending';
import { TrackingVerificationRequests } from './tracking';

interface IIssuerIndexProps {
  match: any;
}

const IssuerIndex = ({ match }: IIssuerIndexProps) => (
  <React.Fragment>
    <Breadcrumbs />
    <Switch>
      <Route
        path={match.url + '/pending'}
        component={PendingVerificationRequests}
      />
      <Route
        path={match.url + '/completed'}
        component={CompletedVerificationRequests}
      />
      <Route
        path={match.url + '/tracking'}
        component={TrackingVerificationRequests}
      />
      <Route
        path={match.url + '/new-verification'}
        component={NewVerification}
      />
      <Route path={match.url + '/dashboard'} component={Dashboard} />
      <Route path={match.url + '/account-history'} component={AccountHistory} />
      <Redirect exact={true} to={match.url + '/dashboard'} />
    </Switch>
  </React.Fragment>
);

export default withRouter(IssuerIndex);
